﻿export * from './home.component';